(function () {
  var MQ = window.matchMedia('(max-width: 767px)');

  function initRoot(root) {
    if (!root || root.dataset.twiReady === 'true') return;
    if (!root.classList.contains('has-mobile-arrows')) return;

    var track = root.querySelector('.text-with-icons__inner');
    var prev = root.querySelector('.text-with-icons__arrow--prev');
    var next = root.querySelector('.text-with-icons__arrow--next');
    if (!track || !prev || !next) return;

    root.dataset.twiReady = 'true';

    function getBlocks() {
      return Array.prototype.slice.call(track.querySelectorAll('.text-with-icons__block'));
    }

    function getCurrentIndex() {
      var blocks = getBlocks();
      if (!blocks.length) return 0;

      var trackRect = track.getBoundingClientRect();
      var center = trackRect.left + trackRect.width / 2;
      var best = 0;
      var bestDist = Infinity;

      for (var i = 0; i < blocks.length; i++) {
        var rect = blocks[i].getBoundingClientRect();
        var blockCenter = rect.left + rect.width / 2;
        var dist = Math.abs(blockCenter - center);
        if (dist < bestDist) {
          bestDist = dist;
          best = i;
        }
      }
      return best;
    }

    function scrollToIndex(index) {
      var blocks = getBlocks();
      if (!blocks.length) return;

      var targetIndex = Math.max(0, Math.min(blocks.length - 1, index));
      var target = blocks[targetIndex];
      var left = target.offsetLeft - (track.clientWidth - target.offsetWidth) / 2;

      track.scrollTo({
        left: Math.max(0, left),
        behavior: 'smooth'
      });
    }

    function updateArrows() {
      if (!MQ.matches) {
        prev.classList.remove('is-disabled');
        next.classList.remove('is-disabled');
        prev.removeAttribute('disabled');
        next.removeAttribute('disabled');
        prev.setAttribute('aria-disabled', 'false');
        next.setAttribute('aria-disabled', 'false');
        return;
      }

      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var left = track.scrollLeft;
      var atStart = left <= 2;
      var atEnd = left >= maxScroll - 2;

      prev.classList.toggle('is-disabled', atStart);
      next.classList.toggle('is-disabled', atEnd);
      prev.toggleAttribute('disabled', atStart);
      next.toggleAttribute('disabled', atEnd);
      prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
      next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }

    function go(dir) {
      if (!MQ.matches) return;
      scrollToIndex(getCurrentIndex() + dir);
    }

    prev.addEventListener('click', function () {
      go(-1);
    });
    next.addEventListener('click', function () {
      go(1);
    });
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    updateArrows();
  }

  function initAll() {
    document.querySelectorAll('.text-with-icons.has-mobile-arrows').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    section.querySelectorAll('.text-with-icons.has-mobile-arrows').forEach(function (root) {
      root.dataset.twiReady = '';
      initRoot(root);
    });
  });
})();
